







import {Component, Vue} from 'vue-property-decorator';
import GlobalHeader from "@/components/GlobalHeader.vue";
import ProductManagementBody from '@/components/product-management/ProductManagementBody.vue';

@Component({
    components: {GlobalHeader, ProductManagementBody}
})
export default class ProductManagement extends Vue {}
